import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-opacity": ".6",
      "stroke-width": "1.25",
      d: "M8.088 8.697a1.862 1.862 0 1 0-.001-3.725 1.862 1.862 0 0 0 0 3.725"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-opacity": ".6",
      "stroke-width": "1.25",
      d: "M8.086 14.75c1.474-.466 5.586-3.724 5.586-7.914a5.587 5.587 0 0 0-11.172 0c0 4.19 4.112 7.448 5.586 7.914"
    }, null, -1)
  ]))]))
}
export default { render: render }